export default __webpack_public_path__ + "static/media/woman-taking-left-pic.16b09be3.jpg";